import "./scss/styles/app.scss";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { I18nContextProvider } from "./i18n";

const root = createRoot(document.getElementById("root"));

root.render(
  <StrictMode>
    <I18nContextProvider>
      <App />
    </I18nContextProvider>
  </StrictMode>,
);
